import script from "./DynamicUrl.vue?vue&type=script&lang=js"
export * from "./DynamicUrl.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__